import { render, staticRenderFns } from "./Important.vue?vue&type=template&id=1689db38"
import script from "./Important.vue?vue&type=script&lang=js"
export * from "./Important.vue?vue&type=script&lang=js"
import style0 from "./Important.vue?vue&type=style&index=0&id=1689db38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports